import { render, staticRenderFns } from "./step9.vue?vue&type=template&id=45d892f4&scoped=true&"
import script from "./step9.vue?vue&type=script&lang=js&"
export * from "./step9.vue?vue&type=script&lang=js&"
import style0 from "./step9.vue?vue&type=style&index=0&id=45d892f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d892f4",
  null
  
)

export default component.exports